export default "__VITE_ASSET__8a48cc29__"